import { Controller } from "@hotwired/stimulus"
import { questionTemplate } from "./templates/question_templates"
import { answersContainerTemplate } from "./templates/answer_templates"

// Connects to data-controller="question-list"
export default class extends Controller {
  static targets = ["questionsContainer", "addButton", "addButtonText"]
  static values = {
    questions: Array,
    maxQuestions: {
      type: Number,
      default: 11
    },
    questionErrors: {
      type: Object,
      default: {}
    },
    predefinedAnswerErrors: {
      type: Object,
      default: {}
    }
  }

  connect() {
    this.nextId = this.questionsValue.length + 1
    this.renderQuestions()
    this.updateAddButton()
  }

  renderQuestions() {
    this.questionsContainerTarget.innerHTML = ""

    this.questionsValue.forEach((question, index) => {
      const questionHtml = this.createQuestionHtml(question, index)
      this.questionsContainerTarget.insertAdjacentHTML("beforeend", questionHtml)
    })
  }

  createQuestionHtml(question, index) {
    const answersHtml = question.predefined_answers
      ? this.createAnswersHtml(question.predefined_answers, question)
      : ""

    const questionErrors = this.questionErrorsValue[question.id] || {}
    const predefinedAnswerErrors = this.predefinedAnswerErrorsValue

    return questionTemplate({
      question,
      index,
      answersHtml,
      questionErrors,
      predefinedAnswerErrors
    })
  }

  createAnswersHtml(predefinedAnswers = [], question = {}) {
    return answersContainerTemplate(predefinedAnswers, this.predefinedAnswerErrorsValue, question)
  }

  addQuestion() {
    if (this.questionsValue.length >= this.maxQuestionsValue)
      return

    const newQuestion = {
      question_type: "custom",
      id: this.nextId,
      question: "",
      is_active: true,
      is_required: false,
      order: this.questionsValue.length + 1,
      predefined_answers: []
    }

    this.questionsValue = [...this.questionsValue, newQuestion]
    this.nextId++
    this.renderQuestions()
    this.updateAddButton()
  }

  removeQuestion(event) {
    const index = event.detail.index
    this.questionsValue = this.questionsValue.filter((_, i) => i !== index)
    this.questionsValue = this.questionsValue.map((q, i) => ({ ...q, order: i + 1 }))
    this.renderQuestions()
    this.updateAddButton()
  }

  updateQuestion(event) {
    const { index, field, value } = event.detail
    const updatedQuestions = [...this.questionsValue]
    updatedQuestions[index] = {
      ...updatedQuestions[index],
      [field]: value
    }
    this.questionsValue = updatedQuestions
  }

  updateAddButton() {
    const currentCount = this.questionsValue.length
    const maxCount = this.maxQuestionsValue
    const isMaxReached = currentCount >= maxCount

    if (this.hasAddButtonTextTarget) {
      this.addButtonTextTarget.textContent = `Add one more question (${currentCount}/${maxCount})`
    }

    if (this.hasAddButtonTarget) {
      this.addButtonTarget.disabled = isMaxReached
    }
  }
}
